// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"371":"4596a189","399":"af27ba49","560":"af27ba49"}[chunkId] + ".css";
};